// extracted by mini-css-extract-plugin
export default {"tooltipIcon":"e5AEjjJUnyM9O2pWs3_ec","tooltip":"_3iOQH7yAcsfSnUS_ZSqVZF","benefitHeading":"_16gRMew7dMcYXxKbEeSVhs"};